import shortid from 'shortid';
import { call } from 'redux-saga/effects';

import * as api from '../api';

const getImageUrlFromUploadUrl = (uploadUrl) => {
  const { origin, pathname } = new URL(uploadUrl);
  return origin + pathname;
};

export const uploadImage = function* (file, options) {
  const { token, publisherId } = options;

  const fileName = `${shortid()}-${file.name}`;

  const uploadUrl = yield call(api.fetchImageUploadUrl, {
    fileName,
    contentType: file.type,
    token,
    publisherId,
  });

  yield call(api.uploadImage, {
    file,
    url: uploadUrl,
  });

  return getImageUrlFromUploadUrl(uploadUrl);
};
